import { PageTitle } from '_metronic/layout/core'

import { SkeletonThumbnailWithContent } from 'Presentation/Components/Loading/Skeleton'
import ProductLineCard from '../Components/ProductLineCard'
import KumopackNewProductCard from 'Presentation/Components/KumopackProductCard/NewProductCard'

import useViewModel from './ViewModel'
import { generateImageUrl } from 'Utils/generateImageUrl'

//////////
// View //
//////////

const ProductionListView: React.FC = () => {
	const { productLines, createNewProductLine, editProductLine, isLoading } = useViewModel()

	return (
		<ViewPageTitle>
			<div className="card border border-kumopack-grey-200" style={{ minHeight: '70vh' }}>
				<div className="card-body" style={{ minHeight: '70vh' }}>
					<div className="row gy-5" style={{ minHeight: '70vh' }}>
						{/* begin:: Quotation */}
						<div className="col-12">
							<div className="row gy-10">
								{isLoading && (
									<>
										{[...Array(6)].map((_, idx) => (
											<div
												className="col-12 col-sm-6 col-lg-6 col-xl-4"
												key={`skeleton-product-line-${idx}`}>
												<div className="card">
													<div className="card-body">
														<SkeletonThumbnailWithContent />
													</div>
												</div>
											</div>
										))}
									</>
								)}

								{!isLoading && (
									<>
										{productLines.map((pl, idx) => (
											<div className="col-12 col-sm-6 col-lg-6 col-xl-4" key={`product-line-item-${idx}`}>
												<ProductLineCard
													title={`${pl.nameTh} (${pl.nameEn ?? '-'})`}
													description={pl.descriptionTh ?? '-'}
													imgPath={
														pl.featurePicturePath
															? generateImageUrl(pl.featurePicturePath)
															: undefined
													}
													edit={() => editProductLine(pl.id, pl.hasChild)}
												/>
											</div>
										))}

										<div className="col-12 col-sm-6 col-lg-6 col-xl-4">
											<KumopackNewProductCard onClick={createNewProductLine} />
										</div>
									</>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>
		</ViewPageTitle>
	)
}

/////////////////////
// View Page Title //
/////////////////////

const ViewPageTitle: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	return (
		<>
			<PageTitle
				breadcrumbs={[
					{
						title: 'General',
						path: '/general/production',
						isActive: false,
						isSeparator: false,
					},
					{
						title: 'Production',
						path: '/general/production',
						isActive: true,
						isSeparator: false,
					},
				]}>
				Production
			</PageTitle>

			{children}
		</>
	)
}

export default ProductionListView
